import dayjs from 'dayjs';

export function isCommentReaded(comment, selfId) {
    return (
        comment &&
        ((comment.date && dayjs(comment.date).isBefore(dayjs().add(-6, 'month'))) ||
            (comment.user && comment.user.id === selfId && comment.src && comment.src === 'CLIENT') ||
            (comment.readers && comment.readers.some((user) => user.id === selfId)))
    );
}
